import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileTypeFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.2 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.34219 0H12L19.2 7.2V20.8756C19.2 22.6027 17.7053 24 15.8642 24H3.34219C1.49468 24 5.27954e-10 22.6027 5.27954e-10 20.8756V3.12443C-3.24369e-05 1.3973 1.49465 0 3.34219 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFileTypeFront;
